import Vue from 'vue'
import { IMaskDirective } from 'vue-imask'

Vue.directive('autofocus', {
  inserted(el) {
    el.focus()
  }
})

Vue.directive('imask', IMaskDirective)
